import type { IconData } from '@stacksjs/iconify-core'

export const eraserFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M30.537 2.683c-1.95-1.516-4.553-1.588-6.573-.13c-2.141 1.546-5.72 4.448-11.236 9.8c-5.516 5.35-8.509 8.822-10.103 10.9c-1.53 1.993-1.451 4.583.134 6.5c1.247 1.509 3.287 3.766 6.566 6.947l.577.556a4.5 4.5 0 0 0 3.24 1.241c2.715-.078 7.268-.16 14.501-.16c.871 0 1.718-.32 2.37-.912a178 178 0 0 0 4.28-4.026c5.517-5.35 8.51-8.823 10.104-10.901c1.529-1.993 1.451-4.582-.134-6.5c-1.247-1.509-3.287-3.766-6.566-6.947s-5.606-5.16-7.16-6.368\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M6.5 44.002A2.5 2.5 0 0 1 8.998 41.5l35-.027a2.5 2.5 0 1 1 .004 5l-35 .027A2.5 2.5 0 0 1 6.5 44.002\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default eraserFlat
